import { thousandSeparated } from 'shared/util/formatting';
import { SpinnerIcon } from 'shared/icons/SpinnerIcon';

import { enrichOfferWithTrackingData } from '@/utils/integration/hotelOfferMapper';
import type { HotelOffer, RoomWithPeople } from '@/interfaces';
import { extractNameFromKey } from '@/utils/kayakKeys';
import { BookingLoginBoundary } from '@/components/bookingLoginBoundary/BookingLoginBoundary';

export interface ResultItemPricesProps {
    hotelId: number;
    hotelKey: string;
    isLoading: boolean;
    offer: HotelOffer;
    country: string;
    place: string;
    checkInDate: Date | number;
    checkOutDate: Date | number;
    rooms: readonly RoomWithPeople[];
}

export const BestPriceBox = ({
    hotelId,
    hotelKey,
    isLoading,
    country,
    offer,
    place,
    checkInDate,
    checkOutDate,
    rooms,
}: ResultItemPricesProps) => {
    const enrichedOffer = enrichOfferWithTrackingData(
        offer,
        country,
        place,
        checkInDate,
        checkOutDate,
        extractNameFromKey(hotelKey),
        hotelId,
    );

    return (
        <div className="result-list-item-price u-bg-marble" data-testid="best-price-box">
            <div className="u-caption u-hide-lt300">Laveste pris {isLoading && <SpinnerIcon className="u-ml8" size={14} />}</div>
            <div data-testid="offer-best-price" className="u-t3 u-mb16">
                {thousandSeparated(offer.totalRate)} kr
            </div>
            <div data-testid="offer-best-price-provider" className="u-caption u-stone u-truncate u-mb4">
                {offer.provider?.nameOverrideSearchResults || offer.provider?.name}
            </div>
            <BookingLoginBoundary
                offer={enrichedOffer}
                rooms={rooms}
                trackingPage="search-result"
                buttonClass="button button--cta button--small"
                buttonText={enrichedOffer.integratedBooking ? 'Bestill nå' : 'Gå til bestilling'}
            />
        </div>
    );
};
